<template>
    <div id="main-content" class="schedule-detail">
        <el-col :offset="1" :span="22">
            <PageTitle :title="title" :backLink="backLink"></PageTitle>
            <el-row>
                <el-form :inline="true">
                    <el-form-item>
                        <el-button type="primary" @click="save()" :disabled="!busStatus">{{ $t('common.save') }}</el-button>
                    </el-form-item>
                </el-form>
            </el-row>

            <el-row>
                <el-col :span="11">
                    <el-col :span="24" style="display: inline">
                        <el-col :span="8">
                            <span class="required-star">* </span><span class="form-lable"> {{$t('moreLanguage.nameTemplate')}}</span>
                        </el-col>
                        <input v-model="data.name" class="input"
                               :placeholder="$t('moreLanguage.nameTemplatePlaceholder')" style="width: 60%">
                        <el-col v-if="error_message.name" :offset="9" :span="15">
                            <span class="form-error"> {{ error_message.name }}</span>
                        </el-col>
                    </el-col>
                </el-col>
                <el-col :span="11" :offset="2">
                    <el-col :span="24" style="display: inline">
                        <el-col :span="8" class="text-right">
                            <span class="required-star">* </span><span
                                class="form-lable"> {{$t('moreLanguage.note')}}</span>
                        </el-col>
                        <textarea v-model="data.note" class="input" :placeholder="$t('moreLanguage.notePlaceholder')"
                                  style="width: 60%; height: auto" rows="4"></textarea>
                        <el-col v-if="error_message.note" :offset="9" :span="15">
                            <span class="form-error"> {{ error_message.note }}</span>
                        </el-col>
                    </el-col>
                </el-col>
            </el-row>
            <hr/>
            <ScheduleAddTemplate v-if="isLoaded" @openStatistic="openStatistic"
                    :data-list="data.data_list" @updateStudentData="updateStudentData"
                    @clearData="clearData" @updateStudentTotal="updateStudentTotal"
                    @updateBusStatus="updateBusStatus"></ScheduleAddTemplate>
        </el-col>
        <el-dialog
                :title="$t('common.statistic')"
                :visible.sync="isStatisticOpen"
                width="50%"
                :before-close="closeStatistic">
            <el-row class="statistic-content" :gutter="20">
                <el-col class="statistic-content__col" :span="8" v-for="placeInfo in statistic" :key="placeInfo.id">
                    <h5>{{ placeInfo.name }}</h5>
                    <table>
                        <tr v-for="(classInfo, classId) in sortClass(placeInfo.classList)" :key="classId">
                            <th width="30%">{{ classInfo.name }}</th>
                            <td>{{ classInfo.count }}</td>
                        </tr>
                    </table>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeStatistic">{{ $t('common.cancel') }}</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    // import {mapState} from 'vuex'
    import PageTitle from '@/components/PageTitle'
    import ScheduleAddTemplate from '@/components/Schedule/ScheduleAddTemplate'
    import {ROUTE_PICKUP} from '@/config'
    // import {classSort} from '@/utils'

    export default {
        name: 'AddTemplate',
        components: {
            PageTitle,
            ScheduleAddTemplate,
        },
        data: function () {
            return {
                backLink: `/schedule/template-list?isType=drop`,
                title: 'moreLanguage.templateAddDrop',
                isStatisticOpen: false,
                statistic: [],
                data: {
                    name: '',
                    note: '',
                    data_list: {}
                },
                error_message: {
                    name: '',
                    note: ''
                },
                isLoaded: false,
                studentTotal: 0,
                busStatus: true
            }
        },
        methods: {
            validate: function () {
                let check = true
                if (this.data.name === "") {
                    this.error_message.name = '* ' + this.$t('moreLanguage.nameTemplate_is_required')
                    check = false
                }
                if (this.data.note === "") {
                    this.error_message.note = '* ' + this.$t('moreLanguage.note_is_required')
                    check = false
                }
                return check
            },
            getData () {
                let dataList = []

                Object.values(this.data.data_list).forEach((studentData) => {
                    let i = this.dataListStudent.findIndex(x=> x.id == studentData.student_id)
                    if (studentData.bus_id && i >= 0) {
                        let data = Object.assign({}, studentData)
                        data.time = this.getTimeStringByObject(data.time)
                        dataList.push(data)
                    }
                })

                return {
                    name: this.data.name.trim(),
                    note: this.data.note.trim(),
                    data_list: dataList
                }
            },
            save: function () {
                if (!this.busStatus) {
                    return
                }

                let check = this.validate()

                if (check) {
                    let successCallback = () => {
                        this.$router.push('/schedule/template-list?isType=drop')
                    }

                    let data = this.getData()

                    let callback = () => {
                        if (this.$route.query.tid) {
                            this.$store.dispatch('schedule/updateTemplate', {
                                data:{
                                    data,
                                    id: this.$route.query.tid
                                },
                                successCallback
                            })
                        } else {
                            this.$store.dispatch('schedule/createTemplate', {
                                data,
                                successCallback
                            })
                        }
                    }

                    if (Object.keys(this.data.data_list).length < this.studentTotal) {
                        this.$store.commit('openConfirm', {
                            title: this.$t('moreLanguage.warning'),
                            message: this.$t('moreLanguage.warning_student_choose'),
                            callback
                        })
                    } else {
                        callback()
                    }
                }
            },
            closeStatistic: function () {
                this.isStatisticOpen = false
            },
            openStatistic(payload) {
                let studentList = payload.studentList
                let routeType = payload.routeType
                let cancelStudentList = []
                let routeField = routeType === ROUTE_PICKUP ? 'pickup' : 'drop'
                let statistic = {}

                this.studentScheduleList.forEach((item) => {
                    if (!item[routeField]) {
                        cancelStudentList.push(item.id)
                    }
                })

                studentList.forEach((item) => {
                    if (cancelStudentList.indexOf(item.id) === -1 && item.place_info && item.class_info) {
                        if (typeof statistic[item.place_info.id] === 'undefined') {
                            statistic[item.place_info.id] = {
                                id: item.place_info.id,
                                name: item.place_info.name,
                                classList: {}
                            }
                        }

                        if (typeof statistic[item.place_info.id].classList[item.class_info.id] === 'undefined') {
                            statistic[item.place_info.id].classList[item.class_info.id] = {
                                id: item.class_info.id,
                                name: item.class_info.name,
                                count: 0
                            }
                        }

                        statistic[item.place_info.id].classList[item.class_info.id].count++
                    }
                })

                this.statistic = Object.values(statistic).sort((before, after) => {
                    let beforeName = before.name.toLowerCase()
                    let afterName = after.name.toLowerCase()

                    return beforeName < afterName ? -1 : beforeName > afterName ? 1 : 0
                })

                this.isStatisticOpen = true
            },
            updateStudentData (studentDataList) {
                this.data.data_list = Object.assign({}, this.data.data_list, studentDataList)
            },
            updateStudentTotal (total) {
                this.studentTotal = total
            },
            clearData () {
                this.data.data_list = {}
            },
            getTimeObjectByString (time) {
                if (!time || time.indexOf(':') === -1) {
                    return {
                        HH: '',
                        mm: ''
                    }
                }

                let times = time.split(':')

                return {
                    HH: times[0],
                    mm: times[1]
                }
            },
            getTimeStringByObject (time) {
                return `${time.HH}:${time.mm}`
            },
            updateBusStatus (status) {
                this.busStatus = status
            },
            retrieveStudentListAll: function () {
                this.$store.dispatch('schedule/retrieveTemplateStudentListAll', {
                    successCallback: (response) => {
                        this.dataListStudent = response.data.data.student_list
                    }
                })
            },
        },
        mounted: function () {
            this.retrieveStudentListAll()
            if (this.$route.query.tid) {
                this.$store.dispatch('schedule/getDetailTemplate', {
                    data: {
                        id: this.$route.query.tid
                    },
                    successCallback: (response) => {
                        let templateInfo = response.data.data.template_info

                        this.data.name = templateInfo.name
                        this.data.note = templateInfo.note

                        templateInfo.data_list.forEach((item) => {
                            item.time = this.getTimeObjectByString(item.time)
                            this.data.data_list[item.student_id] = item
                        })

                        this.isLoaded = true
                    }
                })
            } else {
                this.isLoaded = true
            }
        }
    }
</script>
<style lang="scss">
    .schedule-detail {
        .input {
            float: none !important;
            outline: none;
            background: #fff;
            width: 100%;
        }

        .input[type="text"], select {
            color: #2c3e50;
            font-weight: normal;
        }

        select {
            cursor: pointer;
        }

        .hidden {
            display: none;
        }

        table {
            th, td {
                padding: 10px;
            }

            tr {
                &.cant-pick {
                    td {
                        position: relative;

                        &::before {
                            display: block;
                            width: 100%;
                            height: 100%;
                            content: '';
                            position: absolute;
                            top: 0;
                            left: 0;
                            background: rgba(255, 255, 255, 0.7);
                        }
                    }
                }

                &.pickup-canceled, &.drop-canceled {
                    background: rgba(202, 0, 0, 0.5);
                }
            }
        }

        &__count {
            margin: 20px 0;
        }
    }

    .statistic-content {
        table {
            width: 100%;
        }

        &__col {
            margin-bottom: 20px;
        }
    }
</style>
